
  try {
    var simplXHR1 = new XMLHttpRequest();
    simplXHR1.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        eval(simplXHR1.responseText)
      }
    }
    simplXHR1.open('GET', "https://cdn.getsimpl.com/widget-script-v2/shopify/widget-script.js")
    simplXHR1.send();
    simplXHR1.onerror = function(e) {
      console.log('Error occured while loading simpl widget -> ', e)
    }
  } catch (e) {
    console.log('Error occured while loading simpl widget -> ', e)
  }


    try {
  var simplsessionid = localStorage.getItem('simplsessionid');
  var siimplXHR2 = new XMLHttpRequest();
         siimplXHR2.onreadystatechange = function() {
      if (this.readyState == 4 && this.status == 200) {
        window.SimplMasterConfig = JSON.parse(siimplXHR2.responseText)
        var sessionId = siimplXHR2.getResponseHeader("Simpl-Widget-Session-Token");
        window.simplSessionId = sessionId
        localStorage.setItem('simplsessionid', sessionId);
      }
    }
    siimplXHR2.open('GET', "https://pi3-backend.getsimpl.com/api/v3/app/custom-checkout/widget/master-config?shop=the-wise-store-6673.myshopify.com");
    siimplXHR2.setRequestHeader(
      "Simpl-Widget-Session-Token",
      simplsessionid == 'null'
        ? ""
        : simplsessionid
    );
    siimplXHR2.send();
    siimplXHR2.onerror = function(e) {
      console.log('Error occured while loading simpl widget -> ', e)
    }
  } catch (e) {
    console.log(e);
  }
